module.exports = __webpack_public_path__ + "img/alps-qrcode.18c1a89a.png";